export default {
  message: {
    en: 'If you exit the Avatar Creator now, any unsaved progress will be lost. Only fully created avatars will be saved.',
    ar: 'إذا خرجت من مُصمم الشخصيات الآن، فسيُفقد أي تقدم غير محفوظ. سيتم حفظ الشخصيات المكتملة فقط.'
  },

  confirmTitle: {
    en: 'Do you really want to leave?',
    ar: 'هل حقًا تريد المغادرة؟'
  },

  confirm: {
    en: 'Ok, I am staying',
    ar: 'حسنًا، سأبقى'
  },

  back: {
    en: 'Back to home',
    ar: 'العودة إلى الصفحة الرئيسية'
  }
};
